<template>
  <v-app>
    <v-main>
      <card-login title="Cadastrar">
        <template v-slot:form>
          <form-register :formData.sync="user" ref="form"></form-register>
        </template>
        <template v-slot:control>
          <v-row>
            <v-col>
              <v-btn text color="primary" to="/login">Voltar</v-btn>
            </v-col>
            <v-col>
              <v-btn :loading="loading" block color="primary" @click="clickSubmit">Cadastrar</v-btn>
            </v-col>
          </v-row>
        </template>
      </card-login>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Register",
  components: {
    CardLogin: () => import("@/_auth/components/containers/_auth_card_01.vue"),
    FormRegister: () => import("@/_auth/components/forms/Signup.vue")
  },
  data() {
    return {
      user: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null
      },
      loading: false,
      timeout: 1000
    };
  },
  methods: {
    clickSubmit() {
      this.loading = true;

      setTimeout(() => {
        if (this.$refs.form.validateForm()) {
          this.submitRegister().then(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }, this.timeout);
    },
    submitRegister() {
      return this.$auth
        .register({
          params: {
            name: this.user.name,
            email: this.user.email,
            password: this.user.password,
            password_confirmation: this.user.password_confirmation,
            confirm_success_url: "http://localhost:8080/login"
          }
        })

        .then(response => {
          console.log({ response });
          this.$sweetAlerts.toast1("success", "E-mail de confirmação enviado!");
        })

        .catch(error => {
          console.log("Erro na tentativa de fazer login..", error);
          this.$sweetAlerts.toast1("error", "Algo deu errado!");
        });
    }
  }
};
</script>
